// 获取商品信息的函数
async function getProductByVendor(vendor) {
  const query = `
    query ($vendor: String!) {
        products(first: 20, query: $vendor) {
          edges {
            node {
              id
              handle
              title
              description
              vendor
              metafields(
                identifiers: [{namespace: "wk_custom_field", key: "cus_oiloncanvas"},{namespace: "wk_custom_field", key: "cus_size"},{namespace: "wk_custom_field", key: "cus_isquire"}]
              ) {
                key
                value
              }
              variants(first: 5) {
                edges {
                  node {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    product {
                      id
                      featuredImage {
                        originalSrc
                        altText
                      }
                    }
                    sku
                  }
                }
              }
            }
          }
        }
      }
            `;

  const variables = {
    vendor: vendor,
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      console.log(data);
      // const product = data.productByHandle;
      // console.log(product);
      return data;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}

function fetchGraphQL(query, variables = {}) {
  const endpoint =
    "https://store.magnifissance.com/api/2023-07/graphql.json";
  const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}

const createOtherWorks = async () => {
  const this_product_id = ShopifyAnalytics.meta.product.gid;
  const _ow_list = document.getElementById("ow-list");
  const _verdor_name = document.getElementById("vendor_name");
  const other_works = await getProductByVendor(_verdor_name.innerText);
  let _html = "";
  if (other_works.products && other_works.products.edges.length > 0) {
    let _index = 0;
    for (const prod of other_works.products.edges) {
      if (this_product_id != prod.node.id && prod.node.vendor == _verdor_name.innerText) {
        let _save = create_save(prod.node.id, "/products/" + prod.node.handle);
        let _ooc = "";
        let _size = "";
        let _isquire = "";
        if (prod.node.metafields && prod.node.metafields.length > 0) {
          for (const item of prod.node.metafields) {
            console.log(item);
            if (item && item.key && item.key == "cus_oiloncanvas") {
              _ooc = item.value;
            }
            if (item && item.key && item.key == "cus_size") {
              _size = item.value;
            }
            if (item && item.key && item.key == "cus_isquire") {
              _isquire = item.value;
            }
          }
        }
        let _price = "";
        if (_isquire != "Yes") {
          _price = "$ " + formatCurrency(prod.node.variants.edges[0].node.price.amount);
        } else {
          _price = "Price upon request";
        }
        _index++;
        _html += `<div class="block"><a href="/products/${prod.node.handle}">
        <div class="img">
            <img src=${prod.node.variants.edges[0].node.product.featuredImage.originalSrc}">
        </div></a>
        <div class="info">
        ${_save}
            <div style="display:flex;"><a href="/products/${prod.node.handle}" class="b-title">${prod.node.title}</a></div>
            <div class="attr">${_ooc}</div>
            <div class="rvb-attr2">${_size}</div>
            <div class="price money">${_price}</div>
        </div>
        </div>
    `;
        if (_index == 4) {
          break;
        }
      }
    }
  }
  _ow_list.innerHTML = _html;
};

function formatCurrency(num) {
    num = num.toString().replace(/\$|\,/g,'');
    if(isNaN(num))
        num = "0";
    sign = (num == (num = Math.abs(num)));
    num = Math.floor(num*100+0.50000000001);
    cents = num%100;
    num = Math.floor(num/100).toString();
    if(cents<10)
    cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
    num = num.substring(0,num.length-(4*i+3))+','+
    num.substring(num.length-(4*i+3));
    return (((sign)?'':'-') + num);
}

const create_save = (id, url) => {
  let _id = id.replace("gid://shopify/Product/", "");
  return `
  <div class="add_f_btn" data-id="${_id}" data-url="${url}">
                <div class="inactive"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st03={fill:none;stroke:currentColor;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<path class="st0" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
                <div class="active"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st0s{stroke:#000000;stroke-miterlimit:10;}
</style>
<path class="st0s" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
              </div>
`;
};

const oa_main = async () => {
  await createOtherWorks();
  _btn_add_my_favorites = document.querySelectorAll(".add_f_btn");
  const _btn_add_my_favorites_rv = document.querySelectorAll(".ow-prod-list .add_f_btn");
  console.log("--->",_btn_add_my_favorites.length)
  _btn_add_my_favorites_rv.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
      if (_login_user_) {
        console.log(currentBtn.getAttribute("data-id"));
        const _prod_handle = currentBtn
          .getAttribute("data-url")
          .replace("/products/", "");
        console.log(_prod_handle),
          update_favorites(_prod_handle),
          update_others_this_product_btn(_prod_handle);
      } else window.location.href = "/account/login";
    });
  });
  get_customer_favorites();
};

oa_main();
